import { NodeToolbar } from 'reactflow'
import CloseIcon from '@mui/icons-material/Close'
import { IconButton } from '@mui/material'

const DeleteNodeToolbar = ({ handleNodeDelete, nodeId }) => {
  return (
    <NodeToolbar position='top'>
      <IconButton
        sx={{ border: '1px solid', borderColor: 'error' }}
        color='error' onClick={() => {
          handleNodeDelete(nodeId)
        }}
      ><CloseIcon />
      </IconButton>
    </NodeToolbar>
  )
}

export default DeleteNodeToolbar
